import { render, staticRenderFns } from "./DatingReviewsPage.vue?vue&type=template&id=3ab9c532&scoped=true"
import script from "./DatingReviewsPage.vue?vue&type=script&lang=js"
export * from "./DatingReviewsPage.vue?vue&type=script&lang=js"
import style0 from "./DatingReviewsPage.vue?vue&type=style&index=0&id=3ab9c532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9c532",
  null
  
)

export default component.exports